export var superAdmins = (process.env.REACT_APP_ENV === 'development') ? [
    "M8r0r4vOjhhfRnQmyUOO60Uzmew1" // development
] : [
    "kEin1sEpBYdNByhF0kRNXXtWWoT2" //production
];
// UIDs allowed to enable legacy LTI 1.1 with a default key.
// Keep in sync with legacyLtiOperators in functions/ltiaas_api.js
export var legacyLtiOperators = [
    "DN0hqkN25ag7BB36Wj5ccaeMk4P2",
    //"kEin1sEpBYdNByhF0kRNXXtWWoT2"
];
